app.controller('EmployeeNewStudentDocumentController', ['$scope', '$uibModal', '$stateParams', 'Students', 'StaticData', 'DocumentsService', '$http', 'usSpinnerService', 'toastr', '$state', '$rootScope',
    function ($scope, $uibModal, $stateParams, Students, StaticData, DocumentsService, $http, usSpinnerService, toastr, $state, $rootScope) {
        $scope.doc = {
            type: null,
            studentProfileId: null,
            deadLine: null,
            text: '',
            comment: '',
            attachments: [],
            documentFile: null,
            sheetsNumber : ''
        }
        $scope.format = "dd-MM-yyyy";
        $scope.documentTypes = [];
        $scope.basisFile = null;
        $scope.basisFiles = [];
        $scope.pickerPopup = { opened: false };
        $scope.dateOptions = {
            "is-open": "false",
            dateDisabled: false,
            formatYear: 'yyyy',
            minDate: new Date(),
            startingDay: 1
        };
        $scope.popup1 = {
            opened: false
        };
        $scope.open1 = function () {
            $scope.popup1.opened = true;
        };

        DocumentsService.studentDocTypes().then(function (data) {
            data.forEach(function (type) {
                if (type.parentId === 'INNER')
                    $scope.documentTypes.push(type)
            });
        }).catch(function () {
            usSpinnerService.spin("root");
            toastr.error('', 'დაფიქსირდა შეცდომა');
        });

        $scope.send = function () {
            $scope.doc.studentProfileId = $scope.studentProfileId ? $scope.studentProfileId._id : null;
            if (!$scope.doc.type) toastr.error('', 'გთხოვთ მიუთითოთ დოკუმენტის ტიპი');
            else if (!$scope.doc.studentProfileId) toastr.error('', 'გთხოვთ მიუთითოთ ავტორი');
            else if (!$scope.doc.topic) toastr.error('', 'გთხოვთ შეავსოთ თემატიკა');
            else if ($scope.basisFiles.length !== 1) toastr.error('', 'გთხოვთ დაურთოთ დოკუმენტი ფაილად');
            else {
                usSpinnerService.spin("root");
                $scope.doc.documentFile = $scope.basisFiles[0]._id;
                DocumentsService.registerStudentsDoc($scope.doc).then(function () {
                    usSpinnerService.stop("root");
                    toastr.success('', 'დოკუმენტი წარმატებით დარეგისტრირდა');
                    $rootScope.documentsCount();
                    $state.go('employee.documents.student')
                }).catch(function (err) {
                    usSpinnerService.stop("root");
                    if(err.data === 'OPEN_DOCUMENT_EXISTS') {
                        toastr.error('', 'სტუდენტს უკვე აქვს გამოგზავნილი დოკუმენტი მიმდინარე სტატუსით');
                    } else {
                        toastr.error('', 'დოკუმენტის რეგისტრაციისას დაფიქსირდა შეცდომა');
                    }
                })
            }
        };

        $scope.uploadAttachment = function (type, files) {
            usSpinnerService.spin("root");
            $scope.file = files[0];
            var fd = new FormData();
            if ($scope.file && $scope.file.name) {
                fd.append('file', $scope.file, $scope.file.name);
                $http.post('/documents/attachments', fd, {
                    headers: {'Content-Type': undefined}
                }).then(function (response) {
                    if (type === 'basis') {
                        $scope.basisFiles.push(response.data);
                        $scope.fileName = response.data.name;
                    } else if (type === 'attachment') {
                        $scope.doc.attachments.push(response.data);
                        $scope.fileName = response.data.name;
                    }
                    usSpinnerService.stop("root");
                })
            }
        };

        $scope.removeAttachment = function (type, file) {
            usSpinnerService.spin("root");
            if (type === 'basis' && !file.location) {
                for (var i in $scope.basisFiles) {
                    if (!$scope.basisFiles[i].location && file.name === $scope.basisFiles[i].name) {
                        $scope.basisFiles.splice(i, 1);
                        usSpinnerService.stop("root");
                    }
                }
            } else if (file.location) {
                DocumentsService.removeAttachment(file._id).then(function () {
                    var elementIndex;
                    if (type === 'basis') {
                        elementIndex = _.findIndex($scope.basisFiles, function (basisFile) {
                            return basisFile._id === file._id;
                        });
                        $scope.basisFiles.splice(elementIndex, 1);
                    }
                    if (type === 'attachment') {
                        elementIndex = _.findIndex($scope.doc.attachments, function (attachmentFile) {
                            return attachmentFile._id === file._id;
                        });
                        $scope.doc.attachments.splice(elementIndex, 1);
                    }
                    usSpinnerService.stop("root");
                })
            } else {
                usSpinnerService.stop("root");
            }
        };

        $scope.getStudents = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Students.listEmployee({query: query}).then(function (data) {
                return data.docs;
            });
        };
    }]);
